import { formatMoney } from 'libs/shopify'

function PdpPriceSave({ price, originalPrice }) {
  let discount = 0
  if (price && originalPrice && price < originalPrice) {
    discount += originalPrice - price
  }
  return (
    <>
      {price && originalPrice && price < originalPrice ? (<div className="relative inline-block bg-accent-4 rounded text-xs font-semibold whitespace-nowrap text-white py-[2px] px-2
          before:content-[''] before:absolute before:top-1/2 before:right-full before:-translate-y-1/2 before:border-4 before:border-r-accent-4 before:border-solid before:border-t-transparent before:border-b-transparent before:border-l-0 before:border-r-[5px]
        ">Save {formatMoney(discount)}</div>) : ''}
    </>
  )
}

export default PdpPriceSave
